import fuzzy from 'fuzzy';

import type { Filters, Task } from '../../types';
import { stripHtmlTags, getTaskTitle } from './text';

function matchesSearch(task: Task, query: string): boolean {
    if (!query) {
        return true;
    }

    const title = getTaskTitle(task);
    const plainBody = stripHtmlTags(task.taskContent);

    if (query.startsWith('/')) {
        try {
            const regex = new RegExp(query.slice(1), 'i');
            return regex.test(title) || regex.test(plainBody);
        } catch {
            return false;
        }
    }

    return true;
}

/**
 * Задачи, которые реально рисуются в колонке (поиск + фильтры).
 * Порядок должен совпадать с TasksList — по нему DnD считает индексы.
 */
export function getVisibleTasks(
    tasks: Task[],
    search: string,
    filters: Filters,
): Task[] {
    const query = search || '';
    let result: Task[];

    if (!query) {
        result = tasks;
    } else if (query.startsWith('/')) {
        result = tasks.filter((task) => matchesSearch(task, query));
    } else {
        result = fuzzy.filter(query, tasks, {
            extract: (el) => `${getTaskTitle(el)} ${stripHtmlTags(el.taskContent)}`,
        }).map((item) => item.original);
    }

    if (filters.tags?.length) {
        const tags = filters.tags;
        result = result.filter((task) => task.tags?.some((tag) => tags.includes(tag)));
    }

    if (filters.priority?.length) {
        const priority = filters.priority;
        result = result.filter((task) => (
            task.priority != null
            && priority.some((value) => Number(value) === Number(task.priority))
        ));
    }

    return result;
}
